import { render, staticRenderFns } from "./FincaB.vue?vue&type=template&id=8e2296e2&scoped=true"
import script from "./FincaB.vue?vue&type=script&lang=js"
export * from "./FincaB.vue?vue&type=script&lang=js"
import style0 from "./FincaB.vue?vue&type=style&index=0&id=8e2296e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e2296e2",
  null
  
)

export default component.exports